<script>
  import { onDestroy } from "svelte";
  import { _ } from "./i18n.js";
  import { Link, Toolbar, Icon, Badge } from "framework7-svelte";
  import { getProfile } from "./UserService.js";
  import { getCartDoc } from "./CartService.js";

  export let tabLinkActive;

  let profilePhoto;
  let numberOfPacks;
  let snapshotListener;
  getProfile().then(function(profile) {
    profilePhoto = profile.profilePhoto;

    getCartDoc(profile.userId).then(function(cartDoc) {
      snapshotListener = cartDoc.onSnapshot(async function(cart) {
        numberOfPacks = cart.get("items").length;
      });
    });
  });

  onDestroy(async () => snapshotListener && snapshotListener());

  function isTabLinkActive(path) {
    return path === tabLinkActive;
  }
</script>

<style>
  img.gray {
    filter: grayscale(100%);
  }
</style>

<Toolbar style="font-size: 0.7rem" tabbar labels position="bottom">
  <Link
    href="/Home"
    text={$_('toolbar.home')}
    icon="icon icon-home"
    tabLinkActive={isTabLinkActive('/Home')} />
  <Link
    href="/Products/"
    text={$_('toolbar.products')}
    icon="icon icon-bottle"
    tabLinkActive={isTabLinkActive('/Products/')} />
  <Link
    href="/Cart"
    text={$_('toolbar.cart')}
    tabLinkActive={isTabLinkActive('/Cart')}>
    <Icon icon="icon icon-cart">
      {#if numberOfPacks}
        <Badge color={isTabLinkActive('/Cart') ? 'green' : 'gray'}>
          {numberOfPacks}
        </Badge>
      {/if}
    </Icon>
  </Link>
  <Link
    href="/Order/New"
    text={$_('toolbar.order')}
    icon="icon icon-cargo"
    tabLinkActive={isTabLinkActive('/Order/New')} />
  <Link
    href="/About"
    text={$_('toolbar.about')}
    icon="icon icon-question"
    tabLinkActive={isTabLinkActive('/About')} />
  <Link
    href="/Settings"
    text={$_('toolbar.settings')}
    tabLinkActive={isTabLinkActive('/Settings')}>
    {#if profilePhoto && profilePhoto.length > 0}
      <img
        alt=""
        style="max-width: 25px; border-radius: 50%"
        src={profilePhoto}
        class={isTabLinkActive('/Settings') ? '' : 'gray'} />
    {:else}
      <Icon icon="icon icon-settings" />
    {/if}
  </Link>
</Toolbar>
